import * as React from "react";
import { dropdownViewGet } from "../service/api-service";
import { AutoComplete } from "primereact/autocomplete";
import { FormControl, FormLabel } from "@mui/joy";

interface inputPrams {
  label: string;
  apiPath: string;
  optionLabel: string;
  optionValue: string;
  selectedData?: string | number;
  setSelectedData: React.Dispatch<any>;
  queryParams?: any;
  required?: boolean;
}

export default function AutoCompleteApi(params: inputPrams) {
  const [data, setData] = React.useState<any[]>([]);
  const [items, setItems] = React.useState<any[]>([]);
  const [loading, setLoading] = React.useState(false);
  const [dataLoaded, setDataLoaded] = React.useState(false);

  const loadLazyData = () => {
    if (!loading) {
      setLoading(true);
      dropdownViewGet(params.apiPath, params.queryParams)
        .then(data => {
          setDataLoaded(true);
          const mapping = data.map((e: any) => e[params.optionValue]);
          setData(mapping);
          setLoading(false);
        })
        .catch(error => {
          setData([]);
          setLoading(false);
        });
    }
  };

  const search = (event: any) => {
    setItems(
      data.filter((e: string) => e.toLocaleLowerCase().includes(event.query.toLocaleLowerCase()))
    );
  };

  const setSelected = (event: any) => {
    params.setSelectedData(event);
  };

  React.useEffect(() => {
    loadLazyData();
  }, []);

  return (
    <FormControl>
      <FormLabel>
        {params.label}
        {params.required ? <div style={{ color: "red" }}>*</div> : ""}
      </FormLabel>
      <AutoComplete
        className="PrimeSmallInput"
        completeMethod={search}
        style={{ fontSize: "small", padding: 0 }}
        value={params.selectedData}
        suggestions={items}
        onChange={e => setSelected(e.value)}
      />
    </FormControl>
  );
}
